export const slotKeyCell0 = 'cell0.0';
export const slotKeyBDU0 = 'bdu.0';
export const slotKeyBDU1 = 'bdu.1';

const simIcons = {};
simIcons[slotKeyCell0] = 'terminal-outline';
simIcons[slotKeyBDU0] = 'bdu-1';
simIcons[slotKeyBDU1] = 'bdu-2';
export default simIcons;

export const validSlotKeys = [slotKeyCell0, slotKeyBDU0, slotKeyBDU1];

export const slotStateUnknown = 'Unknown';
export const slotStateNotSelected = 'NotSelected';
export const slotStateSelected = 'Selected';
export const slotStateError = 'SelectedCommsError';

export const validSlotStates = [
  slotStateUnknown,
  slotStateNotSelected,
  slotStateSelected,
  slotStateError,
];

export const slotStateErrorMsg = 'Failure communicating with the SIM card';
export const slotStateUnknownMessage = 'Unknown Error';
